import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  transform(value: any, searchText: string): any {
    if (!searchText) {
      return value;
    }
    return value.replace(new RegExp(searchText, 'gi'), match => {
      return `<strong>${match}</strong>`;
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/pipes/highlight.pipe.ts